import { Hate } from './Hate';
import { Dislike } from './Dislike';
import { Neutral } from './Neutral';
import { Like } from './Like';
import { Love } from './Love';


const Smiley = {}
Smiley.Hate = Hate;
Smiley.Dislike = Dislike;
Smiley.Neutral = Neutral;
Smiley.Like = Like;
Smiley.Love = Love;
export { Smiley };
